<div
    class="d-flex"
    [class.flex-column]="isVertical"
    [class.align-items-center]="!isVertical"
>
    @if (label) {
        <h6 class="me-3 d-none d-sm-block">
            {{ label }}
        </h6>
    }
    @if (items?.length) {
        <ul
            class="legend d-flex mb-0"
            [class.legend--vertical]="isVertical"
            [ngClass]="{ alert: hasContainer }"
        >
            @for (
                item of items;
                track $index;
                let i = $index;
                let first = $first;
                let last = $last
            ) {
                <li
                    class="legend__item d-flex align-items-center"
                    [ngClass]="{
                        'mx-1 mx-sm-2': !isVertical && !first && !last,
                        'me-1 me-sm-2': !isVertical && first && !last,
                        'ms-1 ms-sm-2': !isVertical && last && !first,
                        'mt-1': i > 0 && isVertical,
                        'm-0': first && last && !hasContainer,
                    }"
                >
                    <div
                        class="d-flex align-items-center"
                        [class.flex-column-on-small-screen]="item.iconLetter"
                    >
                        <div class="d-flex align-items-center me-1">
                            @if (item.icon) {
                                <wdx-icon
                                    [iconClass]="
                                        'text-' +
                                        (item.themeColor || item.systemColor)
                                    "
                                    [icon]="item.icon"
                                    [fixedWidth]="true"
                                ></wdx-icon>
                            }
                            @if (item.iconLetter) {
                                <atom-icon-letter
                                    class="d-none d-sm-block"
                                    [iconLetter]="item.iconLetter"
                                ></atom-icon-letter>
                            }
                            @if (
                                item.iconLetter ||
                                item.highlight ||
                                ((item.themeColor || item.systemColor) &&
                                    !item.icon)
                            ) {
                                <atom-highlight-circle
                                    class="d-block"
                                    [class.d-sm-none]="item.iconLetter"
                                    [themeColor]="
                                        item.iconLetter?.highlight ||
                                        item.highlight ||
                                        item.themeColor
                                    "
                                    [systemColor]="item.systemColor"
                                ></atom-highlight-circle>
                            }
                        </div>
                        <div
                            class="legend__label"
                            [class.overline-on-sm-screen]="item.iconLetter"
                        >
                            {{
                                item.translationKey
                                    ? (item.translationKey
                                      | translateTokenisedString)
                                    : item.label
                            }}
                        </div>
                    </div>
                </li>
            }
        </ul>
    }
</div>
